import { render, staticRenderFns } from "./nested-Trades.vue?vue&type=template&id=63ceb8e7&"
import script from "./nested-Trades.vue?vue&type=script&lang=js&"
export * from "./nested-Trades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports